import Lucide from "@/components/Base/Lucide";
import Notification from "@/components/Base/Notification";
import { useTranslation } from "react-i18next";

export default function NotificationAlert() {
    const { t } = useTranslation();

    return (
        <>
            <Notification id="warning-notification-content" className="flex">
                <Lucide icon="XCircle" className="text-warning" />
                <div className="ml-4 mr-4">
                    <div className="font-medium">{t('cannotAddThisProduct')}</div>
                </div>
            </Notification>

            <Notification id="failed-add-stock1" className="flex">
                <Lucide icon="XCircle" className="text-danger" />
                <div className="ml-4 mr-4">
                    <div className="font-medium toast-message">
                    </div>
                </div>
            </Notification>
        </>
    )
}
